<template lang="pug">
AppDialog#schedule-work-confirmation.wow(
  :class="{ opened: show }"
  title="Schedule the work?"
  show
  append-to-body
  has-footer
  @close="closeDialog"
)
  p Are you ready to schedule and assign it?

  template(#footer)
    AppButton(
      type="naked"
      @click="notNow"
    ) Not now
    AppButton(
      type="naked"
      @click="scheduleWork"
    ) Schedule it
</template>

<script>
export default {
  name: 'ScheduleWorkConfirmationDialog',
  props: {
    show: {
      type: Boolean,
      default: () => false,
    },
  },
  methods: {
    closeDialog(scheduleWork = false) {
      this.$emit('close', scheduleWork);
    },
    notNow() {
      this.closeDialog();
    },
    async scheduleWork() {
      this.closeDialog(true);
    },
  },
};
</script>
